import {
  FETCH_MEAL_PULL_LIST,
  FETCH_MEAL_PULL_LIST_SUCCESS,
  FETCH_MEAL_PULL_LIST_FAILURE,
  DOWNLOAD_MEAL_PULL_LIST_PDF,
  DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS,
  DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  residents: null,
  generatedAt: null,
  location: null,
  insights: null,
  prepSummary: null,
  isDownloadingPdf: false,
  error: null,
};

const MealPullListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MEAL_PULL_LIST:
      return { ...state, isFetching: true, error: null };
    case FETCH_MEAL_PULL_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        residents: action.payload?.residents ?? [],
        generatedAt: action.payload?.generatedAt ?? null,
        location: action.payload?.location ?? null,
        insights: action.payload?.insights ?? null,
        prepSummary: action.payload?.prepSummary ?? null,
      };
    case FETCH_MEAL_PULL_LIST_FAILURE:
      return { ...state, isFetching: false, error: true };
    case DOWNLOAD_MEAL_PULL_LIST_PDF:
      return { ...state, isDownloadingPdf: true };
    case DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS:
    case DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE:
      return { ...state, isDownloadingPdf: false };
    default:
      return state;
  }
};

export default MealPullListReducer;
